module.exports = __webpack_public_path__ + "assets/images/journal-header-31d82fece91d2537106601cd739c4ed6.jpg";